exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "", ""]);

// Exports
exports.locals = {
	"primary": "#3d4b9f",
	"secondary": "#f48922",
	"ternary": "#a9a9a9",
	"disabled": "#a9a9a9",
	"text": "#3c4045",
	"text-light": "#7e8287",
	"text-input": "#1d1d1d",
	"text-reverse": "#fff",
	"placeholder": "#b4b8ba",
	"border": "#d2d5d9",
	"page-bg": "#ebedee",
	"error": "#f13333",
	"success": "#0ea036",
	"background": "#eee",
	"#000": "#222831",
	"#fff": "#fff",
	"red": "#f45235",
	"green": "#00a651",
	"gray": "#393e46",
	"gray-darker": "#333232",
	"warning-bg": "rgba(244,137,34,.1)",
	"blue-light": "#e9e9f1"
};